import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={'maintenance' as ErrorTemplateCode}
      title={<ErrorPageTitle label={t('components->>Maintenance.MoreFunctionsWillBeFeatured')} />}
      subtitle={<></>}
    />
  );
};

export default Maintenance;
